<mat-form-field class="mc-search-input no-padding">
  <input
    matInput
    class="sites-search-input"
    [formControl]="searchValue"
    [placeholder]="placeholder"
    (keydown)="keydown($event)"
    (focus)="focusHandler($event)"
    (blur)="blurHandler($event)"
    data-testid="sites-search-input"
  />
  @if (showIcon && !showClearIcon()) {
    <mat-icon class="search-icon" svgIcon="search"></mat-icon>
  } @else if (showClearIcon()) {
    <button class="clear-button" data-testid="search-clear-button" (click)="clearInput()" aria-label="clear search">
      <mat-icon class="clear-button__icon" svgIcon="cross"></mat-icon>
    </button>
  }
  <div class="tooltip">
    <ng-content #outlet></ng-content>
  </div>
</mat-form-field>
